import { motion } from "framer-motion";
import { CHAPTERS, IMAGES } from "@/data/hvm";

export const Manifesto = () => {
  return (
    <section id="approach" data-testid="manifesto-section" className="relative py-24 sm:py-32 noise-overlay">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <motion.p
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="font-tech text-[11px] tracking-[0.3em] uppercase text-[#F4A031]"
              >
                The Access X doctrine
              </motion.p>
              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="font-display font-bold uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight mt-4"
              >
                HVM is not a<br />product. It's a<br />
                <span className="text-[#F4A031]">specification.</span>
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.15 }}
                className="text-[#94A3B8] leading-relaxed mt-5 max-w-md"
              >
                HVM — hostile vehicle mitigation — is the discipline of stopping vehicle-borne
                threats before they reach people and places. Done properly, it starts with a
                threat assessment and ends with a certified barrier, not a catalogue guess.
              </motion.p>
              <motion.div
                initial={{ opacity: 0, scale: 0.96 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="relative mt-10 clip-notch overflow-hidden border border-[#26334D]"
              >
                <img src={IMAGES.engineering} alt="TiSO road blocker and high-security bollard installation" loading="lazy" width="800" height="1064" className="w-full h-64 object-cover opacity-70" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F17] to-transparent" />
                <p className="absolute bottom-4 left-5 font-tech text-[10px] tracking-[0.3em] uppercase text-[#94A3B8]">
                  TiSO shallow road blocker + bollard line
                </p>
              </motion.div>
            </div>
          </div>

          <div className="lg:col-span-7 space-y-0">
            {CHAPTERS.map((c, i) => (
              <motion.div
                key={c.num}
                data-testid={`manifesto-chapter-${c.num}`}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: i * 0.08, duration: 0.6 }}
                className="group border-t border-[#26334D] py-10 flex gap-7 items-start hover:bg-[#131927]/50 transition-colors px-2 -mx-2"
              >
                <span className="font-tech font-bold text-sm text-[#F4A031] pt-2 shrink-0">{c.num}</span>
                <div>
                  <h3 className="font-display font-bold uppercase text-2xl sm:text-3xl tracking-tight text-white group-hover:text-[#F4A031] transition-colors">
                    {c.title}
                  </h3>
                  <p className="text-[#94A3B8] leading-relaxed mt-3 max-w-xl">{c.body}</p>
                </div>
              </motion.div>
            ))}
            <div className="border-t border-[#26334D]" />
          </div>
        </div>
      </div>
    </section>
  );
};
